import { FC } from 'react';
import styled from 'styled-components';
import { useFormContext } from 'react-hook-form';
import { Colors } from '../../../../assets';
import { Spacing } from '../../../../assets/GlobalStyle/Variables';
import { ComplementType, RequestsFormValues } from '../models';
import {
  BiochemistryForm,
  CTForm,
  GeneticsForm,
  HistochemistryMakroForm,
  HistologyForm,
  MicrobiologyForm,
  NRLOtherForm,
  NRLRespiratoryForm,
  OtherForm,
  RTGForm,
  ToxicologyForm,
  TransportForm,
  TryptaseForm,
  VirologyForm
} from './forms';

const TITLE_BY_TYPE: Record<ComplementType, string> = {
  toxicology: 'Toxikologie',
  rtg: 'RTG',
  ct: 'CT',
  tryptase: 'Tryptáza',
  microbiology: 'Mikrobiologie',
  histology: 'Histologie',
  histochemistry_makro: 'Histochemie - makro',
  nrl_respiratory: 'NRL respirační',
  nrl_other: 'NRL jiné',
  genetics: 'Genetika',
  biochemistry: 'Biochemie',
  transport: 'Transport',
  virology: 'Virologie',
  other: 'Ostatní'
};

const renderForm = (type: ComplementType) => {
  switch (type) {
    case 'toxicology':
      return <ToxicologyForm />;
    case 'rtg':
      return <RTGForm />;
    case 'ct':
      return <CTForm />;
    case 'tryptase':
      return <TryptaseForm />;
    case 'microbiology':
      return <MicrobiologyForm />;
    case 'histology':
      return <HistologyForm />;
    case 'histochemistry_makro':
      return <HistochemistryMakroForm />;
    case 'nrl_respiratory':
      return <NRLRespiratoryForm />;
    case 'nrl_other':
      return <NRLOtherForm />;
    case 'genetics':
      return <GeneticsForm />;
    case 'biochemistry':
      return <BiochemistryForm />;
    case 'transport':
      return <TransportForm />;
    case 'virology':
      return <VirologyForm />;
    case 'other':
      return <OtherForm />;
    default:
      return null;
  }
};

export const ComplementForms: FC = () => {
  const { watch } = useFormContext<RequestsFormValues>();
  const selectedComplement = watch('selectedComplement');

  if (!selectedComplement) {
    return (
      <EmptyState>
        Vyberte typ žádanky. Podle výběru se zobrazí příslušný formulář.
      </EmptyState>
    );
  }

  return (
    <Section>
      <SectionTitle>{TITLE_BY_TYPE[selectedComplement]}</SectionTitle>
      <SectionBody>{renderForm(selectedComplement)}</SectionBody>
    </Section>
  );
};

const Section = styled.section`
  border: 1px solid ${Colors.lightGrey};
  background: #fff;
`;

const SectionTitle = styled.div`
  width: 100%;
  padding: ${Spacing(3)} ${Spacing(4)};
  font-weight: 700;
  background: ${Colors.lightBackground};
  border-bottom: 1px solid ${Colors.lightGrey};
`;

const SectionBody = styled.div`
  padding: ${Spacing(4)};
`;

const EmptyState = styled.div`
  border: 1px dashed ${Colors.lightGrey};
  color: ${Colors.grey};
  background: ${Colors.lightBackground};
  padding: ${Spacing(4)};
`;
